import React, {useEffect} from "react";
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { delLogin } from '../../slices/user/UserSlice';
import axios from 'axios';
import Test from "../elements/Timer";

export default function Navbar() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serverName = useSelector((state) => state.app.server);
    const mainMenu  = useSelector((state) => state.menu.main);
    const authMenu  = useSelector((state) => state.menu.auth);
    const userLogin = useSelector((state) => state.user.login);

    useEffect(() => {
        let menuItems = document.getElementsByClassName('nav-item');

        for (let item of menuItems) {
            item.addEventListener('click', closeMenu)
        }

        return () => {
            for (let item of menuItems) {
                item.removeEventListener('click', closeMenu)
            }
        }
    })

    function closeMenu(){
        document.getElementById('navbarSupportedContent').classList.remove("show");
    }

    function handleLogout() {
        axios.post('/logout')
            .then(()=>{
                dispatch(delLogin());
                localStorage.removeItem('endAuthTime')
                console.log("was logout");
                navigate('/')
            })
    }

    let userLoginOutput = userLogin ? '('+ userLogin +')' : null

    let j = 0;
    let mainLinks = mainMenu.map((item)=>
        <li className="nav-item" key={j++}>
            <NavLink
                className={ 'nav-link ' }
                key={j++}
                to={item.path}
            >
                {item.name}
            </NavLink>
        </li>
    )

    let i = 0;
    let authLinks = authMenu.map((item)=> {
            if (item.path === '/logout') {
                return <NavLink
                    className={'nav-link '}
                    key={i++}
                    to={item.path}
                    onClick={handleLogout}
                >
                    <Test endAuthTime={localStorage.getItem('endAuthTime')}/> {userLoginOutput} {item.name}
                </NavLink>
            } else {
                return <NavLink
                    className={'nav-link '}
                    key={i++}
                    to={item.path}
                >
                    {item.name}
                </NavLink>
            }
        }
    );


    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <Link className='logo' to="/">{serverName}</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Переключатель навигации">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            { mainLinks }
                        </ul>
                        <ul className="navbar-nav">
                            { authLinks }
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}